import { useState } from 'react';
import { Link } from 'react-router-dom';
import {Button,Spinner} from 'react-bootstrap';
import Form from 'react-bootstrap/Form';
import Modal from 'react-bootstrap/Modal';
import axios from 'axios';
import {InputF} from '../../components//Input';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEye,faFilePen } from '@fortawesome/free-solid-svg-icons';
import  { Alert2 } from '../../components/Alerte';
function Update() {
    const [message,setMessage] = useState('')
    const [ok,setOk] = useState(false)
    const [selectedFiles, setSelectedFiles] = useState({
        "cv":true,
        "copie_carte_id" : true,
        "demande" : true,
        "lettre_motivation" : true,
        "copie_diplome" : true,
        "recommandation1" : true,
        "recommandation2" : true,
        "resume_these" : true,
        "publication_scientifique" : true,
        "attestation_travail" : true,
        "justificatif1" : true,
        "justificatif2" : true,
        "justificatif3" : true,
        "justificatif4" : true,
        "justificatif5" : true,
        "justificatif6" : true,
        "communication" : true,
        "diplome2" : true,
        "diplome3" : true,
        "diplome4" : true,
        "diplome5" : true,
        "diplome6" : true,
        "justificatif7" : true,
        "justificatif8" : true,
        "communication2" : true,
        "communication3" : true,
        "communication4" : true,
        "communication5" : true,
        "publication2" : true,
        "publication3" : true,
        "publication4" : true,
        "publication5" : true,
        "publication6" : true,
        "publication7" : true,
        "publication8" : true,
        "publication9" : true,
        "publication10" : true,
    });
    const [gestionfichier, setGestionFichier] = useState({
        "cv":false,
        "copie_carte_id" : false,
        "demande" : false,
        "lettre_motivation" : false,
        "copie_diplome" : false,
        "recommandation1" : false,
        "recommandation2" : false,
        "resume_these" : false,
        "publication_scientifique" : false,
        "attestation_travail" : false,
        "justificatif1" : false,
        "justificatif2" : false,
        "justificatif3" : false,
        "justificatif4" : false,
        "justificatif5" : false,
        "justificatif6" : false,
        "communication" : false,
        "diplome2" : false,
        "diplome3" : false,
        "diplome4" : false,
        "diplome5" : false,
        "diplome6" : false,
        "justificatif7" : false,
        "justificatif8" : false,
        "communication2" : false,
        "communication3" : false,
        "communication4" : false,
        "communication5" : false,
        "publication2" : false,
        "publication3" : false,
        "publication4" : false,
        "publication5" : false,
        "publication6" : false,
        "publication7" : false,
        "publication8" : false,
        "publication9" : false,
        "publication10" : false,
    });
    const [editField, setEditField] = useState(null);
    const [otp,setOtp] = useState(''); //etat pour gérer si oui on non le codeOTP est correct 
  const handleEditFile = (field) => {
    setEditField(field);
  };
    const [FieleFields, setFileFields] = useState('');
    const maxFileSize = 1024 * 1024 * 2;
    const [dataForm, setDataForm] = useState('');
    const [show, setShow] = useState(true);
    const [click, setClick] = useState(false);
    const [click2, setClick2] = useState(false);
    const [auth,setAuth] = useState(false);
    const [email,setEmail] = useState('');
    const [showU,setShowU] = useState(true);
    const [data,setData] = useState({});
    const [poste,setPoste] = useState('');
    const [dataFetch,setDataFtech] = useState('')
    const [errors,setErros] = useState(false);
    const [inputOtp,setInputOTP] = useState(1); //champs input qui récupère le code OTP
    const handleClose = () => setShow(false);
    const handleChange = (e) => {
        setEmail(e.target.value)
    }
    const handleChangeOTP = (e) => {
        setInputOTP(e.target.value)
    }
    function onChangeUpdate (e) {
        const name = e.target.name
        const value = e.target.value
        setDataForm({ ...dataForm, [name]: value });
    }
    const handleFileChange = (event, key) => {
        // console.log(selectedFiles.publication7)
        const file = event.target.files[0];
        const elements = document.getElementsByName(key)
        if (file?.size < maxFileSize){
            setSelectedFiles((prevSelectedFiles) => ({
                ...prevSelectedFiles,
                [key]: file
            }));
            setGestionFichier((prevSelectedFiles) => ({
                ...prevSelectedFiles,
                [key]: true
            }));
            for (var i = 0; i < elements.length; i++) {
                var element1 = elements[i];
                // console.log(element)
                // Faites quelque chose avec chaque élément, par exemple :
                element1.style.border = ""; // Applique une bordure rouge
                // ... autres opérations sur l'élément
            }
        } else {
            setSelectedFiles((prevSelectedFiles) => ({
                ...prevSelectedFiles,
                [key]: false
            }));
            setGestionFichier((prevSelectedFiles) => ({
                ...prevSelectedFiles,
                [key]: false
            }));
            for (var j = 0; j < elements.length; j++) {
                var element = elements[j];
                // console.log(element)
                // Faites quelque chose avec chaque élément, par exemple :
                element.style.border = "2px solid #BC0C0C";
                element.style.transition ='border 0.5s ease-in-out;' // Applique une bordure rouge
                // ... autres opérations sur l'élément
            }
    
        }
    };
    const handleSubmit = async (e) => {
        e.preventDefault();
        setClick(true);
        if (!showU) {
            setClick2(true);
        }
        // console.log(typeof(dataForm))
        if (auth) {
            try {
                const formData = new FormData();
                formData.append('email',email)
                if (dataForm.hasOwnProperty('nom')) {
                    // console.log('existe')
                } else {
                    formData.append('nom',data?.nom)
                }
                if (dataForm.hasOwnProperty('date_naissance')) {
                    // console.log('existe')
                } else {
                    formData.append('date_naissance',data?.date_naissance)
                }
                if (dataForm.hasOwnProperty('prenom')) {
                    // console.log('existe')
                } else {
                    formData.append('prenom',data?.prenom)
                }
                if (dataForm.hasOwnProperty('poste')) {
                    // console.log('existe')
                } else {
                    formData.append('poste',poste)
                }
                const nameFiles = ["cv","copie_carte_id","demande","lettre_motivation","copie_diplome","communication","recommandation1","recommandation2","resume_these",
            "publication_scientifique","attestation_travail","justificatif1","justificatif2","justificatif3","justificatif4","justificatif5","justificatif6",
            "diplome2","diplome3","diplome4","diplome5","diplome6","justificatif7","justificatif8","communication2","communication3","communication4",
            "communication5","publication2","publication3","publication4","publication5","publication6","publication7","publication8","publication9","publication10"]
            for (const i in nameFiles) {
                if (selectedFiles[nameFiles[i]]) {
                    if ((selectedFiles[nameFiles[i]]).size <= maxFileSize) {
                        formData.append(nameFiles[i] , selectedFiles[nameFiles[i]])
                    } else {
                        // console.log("fichier trop gros");
                    }
                }
            }
                for (let key in dataForm) {
                    if (dataForm.hasOwnProperty(key)) {
                        if( dataForm[key] !== null) {
                            formData.append(key ,dataForm[key])
                        }
                    }
                }
                 for (let pair of formData.entries()) {
                // console.log(pair[0] + ':' + pair[1]);
              }
                const response = await axios.post(
                    'https://depot.uam.sn/api/v1/recrutement/update',
                    formData,
                    {
                        headers: {
                        'Content-Type': 'multipart/form-data',
                        },
                    });
                if (response.status === 200) {
                        // console.log(response.data);
                        setClick(false);
                        setClick2(false)
                        setOk(true)
                        setMessage('Données mises à jour avec succès');
                }
                // console.log(dataForm)
            } catch (error) {
               console.error('Error', error);
               setClick(false)
               setClick2(false)
            }
        } else {
            // console.log("Send to API "+email)
            axios({
                url:`https://depot.uam.sn/api/v1/recrutement/confirmed/?email=${email}`,
                method: 'POST',
            })
            .then(result => {
                if (!result.data.detail) {
                    let fields = ["prenom", "nom", "email", "telephone",
                     "civilite","date_naissance","lieu_naissance","address",
                    "pays","annee_experience"]
                    // console.log("Initialisation Success");
                    // console.log('Data from API :', result.data);
                    setDataFtech(result.data.data)
                    setPoste(result.data.data.poste)
                    setOtp(result.data.otp)
                    let test = result.data.data
                    test = Object.entries(test);
                    // console.log(test[11][1])
                    test.forEach(([key, value]) => {
                        if( (value !== null) && (key !== 'email' && key !== 'date_depot' && key !== 'diplome'
                        && key !== 'type_poste'  && key !== 'ecole_postulee' && key !=='poste') ){
                            if (fields.includes(key)) {
                                setData(prevData => ({ ...prevData, [key]: value }));
                            } else {
                                setFileFields(prevData => ({ ...prevData, [key]: value }));
                            }
                        }
                    });
                    setAuth(true)
                    setClick(false)
                } else {
                    alert(result.data.detail)
                    setClick(false)
                }
            })
            .catch((error) => {
                console.error('Error:', error);
                setClick(false)
                
            });
        }
    }
  return (
    <>
    {ok ? <Alert2 message={message} /> : null}
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Mon Dossier</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            {!auth ? <>
                <Form>
                <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
              <Form.Label>Email address</Form.Label>
              <Form.Control
                type="email"
                name='email'
                required
                onChange = {handleChange}
                placeholder="name@example.com"
                autoFocus
              />
            </Form.Group>
          </Form>
            </> :
            <>
            <Form>
            <div className="container p-1 fs-5" id='home'> 
                {!showU ? 
                    <>
                        <div>
                            {Object.entries(data).map(([key,value]) => (
                                <Form.Group className="" id="">
                                <Form.Label className='fw-medium'>{key ==='annee_experience' ? 'Grade Cames ' : key} :  </Form.Label>
                                    <Form.Control
                                    className=""
                                    size='md'
                                    type={key === 'date_naissance' ? 'date' : 'text'}
                                    name={key}
                                    readOnly={key === 'annee_experience' ? true : false}
                                    defaultValue={value}
                                    onChange={onChangeUpdate}
                                    />
                                </Form.Group>
                                )) 
                            }
                        </div>
                        <div>
                            {Object.entries(FieleFields).map(([key,value]) => (
                                <>{key} : 
                                    <Link to={`https://depot.uam.sn/api/v1/recrutement/view/${poste}/${value}`} target='_blank'>
                                    <FontAwesomeIcon icon={faEye} className='btn btn-primary mr-2' />
                                    </Link>
                                    <Link to="#" onClick={() => handleEditFile(key)}>
                                        <FontAwesomeIcon icon={faFilePen} className='btn btn-warning mr-2' />
                                    </Link> <br />
                                    {editField === key && (
                                    <>
                                        <InputF
                                            required={true}
                                            className="rounded-left mb-2"
                                            label={key}
                                            message={<span style={{ color: 'red' }}>*</span>}
                                            type='file'
                                            name={key}
                                            onChange={(e) => handleFileChange(e, key)}
                                        />
                                        {!selectedFiles[key] && <span style={{ color: 'red' }}>La taille du fichier doit être inférieure à 2 Mo. Veuillez le réduire.</span>}
                                    </>
                                    )}
                                </>   
                                ))
                            }  
                        {dataFetch.justificatif1 ===null ? <><InputF className="rounded-left mb-2" label="Autres éléments de preuve pouvant justifier le CV" type='file' name='justificatif1' onChange={(e) => handleFileChange(e,"justificatif1")} />  
                        {!selectedFiles["justificatif1"]? <span style={{color:'red'}}>taille du fichier {'>'} 2 Mo veuiller le réduire . </span>: null}</> : null} 
                        {dataFetch.justificatif2 ===null ? <><InputF className="rounded-left mb-2" label="" type='file' name='justificatif2' onChange={(e) => handleFileChange(e,"justificatif2")} />  
                        {!selectedFiles["justificatif2"]? <span style={{color:'red'}}>taille du fichier {'>'} 2 Mo veuiller le réduire . </span>: null}</> : null} 
                        {dataFetch.justificatif3 ===null ? <><InputF className="rounded-left mb-2" label="" type='file' name='justificatif3' onChange={(e) => handleFileChange(e,"justificatif3")} />  
                        {!selectedFiles["justificatif3"]? <span style={{color:'red'}}>taille du fichier {'>'} 2 Mo veuiller le réduire . </span>: null}</> : null} 
                        {dataFetch.justificatif4 ===null ? <><InputF className="rounded-left mb-2" label="" type='file' name='justificatif4' onChange={(e) => handleFileChange(e,"justificatif4")} />  
                        {!selectedFiles["justificatif4"]? <span style={{color:'red'}}>taille du fichier {'>'} 2 Mo veuiller le réduire . </span>: null}</> : null} 
                        {dataFetch.justificatif5 ===null ? <><InputF className="rounded-left mb-2" label="" type='file' name='justificatif5' onChange={(e) => handleFileChange(e,"justificatif5")} />  
                        {!selectedFiles["justificatif5"]? <span style={{color:'red'}}>taille du fichier {'>'} 2 Mo veuiller le réduire . </span>: null}</> : null} 
                        {dataFetch.justificatif6 ===null ? <><InputF className="rounded-left mb-2" label="" type='file' name='justificatif6' onChange={(e) => handleFileChange(e,"justificatif6")} />  
                        {!selectedFiles["justificatif6"]? <span style={{color:'red'}}>taille du fichier {'>'} 2 Mo veuiller le réduire . </span>: null}</> : null} 
                        {dataFetch.justificatif7 ===null ? <><InputF className="rounded-left mb-2" label="" type='file' name='justificatif7' onChange={(e) => handleFileChange(e,"justificatif7")} />  
                        {!selectedFiles["justificatif7"]? <span style={{color:'red'}}>taille du fichier {'>'} 2 Mo veuiller le réduire . </span>: null}</> : null} 
                        {dataFetch.justificatif8 ===null ? <><InputF className="rounded-left mb-2" label="" type='file' name='justificatif8' onChange={(e) => handleFileChange(e,"justificatif8")} />  
                        {!selectedFiles["justificatif8"]? <span style={{color:'red'}}>taille du fichier {'>'} 2 Mo veuiller le réduire . </span>: null}</> : null} 
                        
                        </div>
                    </> 
                :       <div>
                            Nom & Prenom : <span className='' style={{fontWeight:'bold'}}>{data.nom} {data.prenom}</span><br />
                            <span>Poste à pourvoir : <span className='mb-3' style={{fontWeight:'bold'}}>{data.poste}</span></span>
                            <Form.Group className="mb-1" id="">
                                    <Form.Label className='fw-medium'><span> Rensigner le code OTP envoyé par mail pour faire une modification :  </span></Form.Label>
                                        <Form.Control
                                        className="w-50"
                                        size='md'
                                        type='number'
                                        name='otp'
                                        placeholder='0XXXX'
                                        onChange={handleChangeOTP}
                                        />
                            </Form.Group>
                            <Button className='flex-end' variant="warning" onClick={()=> {parseInt(inputOtp) === parseInt(otp) ? setShowU(false) : setErros(true)}}>Vérifier le Code</Button>
                            {errors ? <><div className="alert alert-danger w-50 p-2 m-1" role="alert">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="18" fill="currentColor" className="bi bi-exclamation-triangle" viewBox="0 0 16 16">
                                            <path d="M7.938 2.016A.13.13 0 0 1 8.002 2a.13.13 0 0 1 .063.016.146.146 0 0 1 .054.057l6.857 11.667c.036.06.035.124.002.183a.163.163 0 0 1-.054.06.116.116 0 0 1-.066.017H1.146a.115.115 0 0 1-.066-.017.163.163 0 0 1-.054-.06.176.176 0 0 1 .002-.183L7.884 2.073a.147.147 0 0 1 .054-.057zm1.044-.45a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566z"/>
                                            <path d="M7.002 12a1 1 0 1 1 2 0 1 1 0 0 1-2 0zM7.1 5.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995z"/>
                                            </svg> Code OTP Incorrect
                                        </div></> : null}
                        </div>
                    }
                
            </div>
            </Form>   
                
            </>}
        </Modal.Body>
        <Modal.Footer>
            {auth ?  <Button disabled={showU===true ? true : false} variant="warning" onClick={handleSubmit}>
            Modifier
          </Button> :  <Button variant="primary" onClick={handleSubmit}>
            {click ? <>En cours  <Spinner animation="grow" variant="primary" size="sm" /></> : 'Envoyer' }  
            {click2 ? <>En cours  <Spinner animation="grow" variant="primary" size="sm" /></> : '' }  
          </Button>} 
         
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default Update;